<template>
	<apexchart
		:width="width"
		:height="dynamicHeight"
		:options="chartOptions"
		:series="parsedData"
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

export default {
  name: "Chart2",
  components: {
    apexchart: VueApexCharts,
    moment,
  },
  props: {
    width: {
      type: [Number, String],
      default: "100%",
    },
    height: {
      type: [Number, String],
      default: "100%", // Usa altura calculada internamente
    },
    value: {
      type: Number,
      default: 75,
    },
    data: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data() {
    return {
			barHeight: 20,
      categories: [],
    };
  },
  computed: {
    parsedData() {
      // Se data não for objeto, ou for array, ou for objeto vazio, retorna dois arrays vazios
      if (!this.data || typeof this.data !== 'object' || Array.isArray(this.data) || !Object.keys(this.data).length) {
        this.categories = [];
        return [
          { name: "Tempo Médio de Atendimento (TMA)", data: [] },
          { name: "Tempo Médio de Espera (TME)", data: [] }
        ];
      }
      const keys = Object.keys(this.data);
      this.categories = keys;
      const tmaArray = [];
      const tmeArray = [];
      Object.values(this.data).forEach(el => {
        tmaArray.push(el && typeof el === 'object' && typeof el.tma === 'number' ? el.tma : 0);
        tmeArray.push(el && typeof el === 'object' && typeof el.tme === 'number' ? el.tme : 0);
      });
      return [
        { name: "Tempo Médio de Atendimento (TMA)", data: tmaArray },
        { name: "Tempo Médio de Espera (TME)", data: tmeArray }
      ];
    },
    dynamicHeight() {
      const categoriesCount = this.categories.length;
      const spacingPerCategory = 30;
      const titleAndLegendSpace = 50;

			const total = (categoriesCount * (this.barHeight * 2 + spacingPerCategory)) + titleAndLegendSpace;
      
			return total
		},
    
    chartOptions() {
      return {
        title: {
          text: "Tempo Médio por Fila (em minutos)",
          align: "center",
          style: {
            fontSize: "14px",
            fontWeight: "bold",
          },
        },
        chart: {
          type: "bar",
          height: this.dynamicHeight,
          toolbar: {
            show: false
          }
        },
        colors: ["#4da6ff", "#ff6666"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: this.barHeight,
            dataLabels: {
              position: 'center',
            },
            grouped: true,
            groupPadding: 0.3,
            categoryGap: '40%',
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"],
            fontSize: "11px",
            fontWeight: "bold",
          },
          formatter: (val) => moment.utc(val * 1000).format("mm:ss"),
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 1,
            opacity: 0.9,
            color: "black",
          },
        },
        xaxis: {
          categories: (!this.data || typeof this.data !== 'object' || Array.isArray(this.data) || !Object.keys(this.data).length)
            ? []
            : Object.keys(this.data),
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            show: false,
            formatter: (val) => `${val}%`,
          },
        },
        yaxis: {
          show: !!this.categories.length,
        },
        grid: {
          show: !!this.categories.length,
          padding: {
            right: 60
          }
        },
        tooltip: {
          enabled: false,
          y: {
            formatter: function (val) {
              return moment.utc(val * 1000).format("mm:ss");
            },
          },
        },
        legend: {
          show: true,
          position: "top",
        },
      };
    },
  },
};
</script>

<style scoped>
.example {
  padding: 0 10px;
}
</style>